import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import CurrentDayTime from '../14-currentDate/CurrentDayTime';
import arrow from '../../images/arrow.svg'
import Navbar from '../01-navbar/Navbar';
import axios from 'axios';
import { format } from 'date-fns';
import { LoaderContext } from '../15-loader/LoaderProvider';

const JodiChart = () => {

    const { id } = useParams()

    const { setIsLoading } = useContext(LoaderContext);

    const navigate = useNavigate()
    const tableTop = useRef(null);
    const tableBottom = useRef(null);

    const topToTable = () => {
        window.scrollTo({
            top: tableTop.current.offsetTop,
            behavior: 'instant',
        });
    }

    const bottomToTable = () => {
        window.scrollTo({
            top: tableBottom.current.offsetTop,
            behavior: 'instant',
        });
    }


    const getChart = async () => {
        await axios.get(`${process.env.REACT_APP_BASE_URL}/web/chart/${id}`)
            .then((response) => {
                setJodichartApiData(response.data.data)
                setIsLoading(false)
            })
            .catch((err) => console.log(err.message))
    }
    useEffect(() => {
        getChart()

    }, [])

    const [jodichartApiData, setJodichartApiData] = useState([]);

    const DateToLocalDateString = (date) => format(new Date(date), 'dd-MMM-yyyy');

    function sumGetLastDigit(value) {

        if (value == null) {
            return null;
        } else {
            return (
                value
                    .toString()
                    .split('')
                    .map(Number)
                    .reduce(function (a, b) {
                        return a + b;
                    }, 0) % 10
            );
        }
    }


    return (
        <div className='jodichart'>

            <>

                <div className='shribet-navbar' ref={tableTop}><Navbar /></div>

                <div className='panachart'>

                    <div className='panachart-content'>

                        <div className='container'>


                            <div className='panachart-sub-heading'>

                                <div className='panachart-back-button' onClick={() => navigate('/market-result')} ><span className='arrow-icon'><img src={arrow} /></span><span className='back'>BACK</span></div>
                                <div className='panachart-heading' ><h2>{jodichartApiData.marketName}</h2></div>
                                <div className='panachart-bottom-button' onClick={bottomToTable} ><span className='arrow-icon'><img src={arrow} /></span><span className='back'>BOTTOM</span></div>

                            </div>

                            <div className='panachart-sub-heading-new'>

                                <div className='panachart-button'>

                                    <div className='panachart-back-button' onClick={() => navigate('/market-result')} ><span className='arrow-icon'><img src={arrow} /></span><span className='back'>BACK</span></div>
                                    <div className='panachart-bottom-button' onClick={bottomToTable} ><span className='arrow-icon'><img src={arrow} /></span><span className='back'>BOTTOM</span></div>

                                </div>

                            </div>

                            <div className='chart'  >

                                <table className="table align-middle text-center">

                                    <thead className='table-head'>

                                        <tr>
                                            <th>Date</th>
                                            <th>Monday</th>
                                            <th>Tuesday</th>
                                            <th>Wednesday</th>
                                            <th>Thursday</th>
                                            <th>Friday</th>
                                            <th>Saturday</th>
                                            <th>Sunday</th>
                                        </tr>

                                    </thead>

                                    <tbody className='table-body'>

                                        {
                                            jodichartApiData?.marketData?.map((data, index) =>

                                                <tr key={index}>

                                                    <th className='table-date'>
                                                        <div><h6>{DateToLocalDateString(data.dateFrom)}</h6></div>
                                                        <div><h6>to</h6></div>
                                                        <div><h6>{DateToLocalDateString(data.dateTo)}</h6></div>
                                                    </th>

                                                    {
                                                        data.days.map((e, index) =>

                                                            <td key={index}>
                                                                <div className='table-result'>

                                                                    <div className='main-result'><h6>{e.open ? sumGetLastDigit(e.open) : <div className='star'>*</div>}{e.close ? sumGetLastDigit(e.close) : <div className='star'>*</div>}</h6></div>

                                                                </div>
                                                            </td>

                                                        )
                                                    }

                                                </tr>

                                            )
                                        }

                                    </tbody>

                                </table>

                            </div>



                            {/* <div className='chart'>

                                <table className="table align-middle text-center">
                                    <thead className='table-head'>
                                        <tr>
                                            <th>Date</th>
                                            <th>Monday</th>
                                            <th>Tuesday</th>
                                            <th>Wednesday</th>
                                            <th>Thursday</th>
                                            <th>Friday</th>
                                            <th>Saturday</th>
                                            <th>Sunday</th>
                                        </tr>
                                    </thead>
                                    <tbody className='table-body'>

                                        <tr>
                                            <th className='table-date'>
                                                <div><h6>22-May-2023</h6></div>
                                                <div><h6>to</h6></div>
                                                <div><h6>28-May-2023</h6></div>
                                            </th>

                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            

                                        </tr>
                                        <tr>
                                            <th className='table-date'>
                                                <div><h6>22-May-2023</h6></div>
                                                <div><h6>to</h6></div>
                                                <div><h6>28-May-2023</h6></div>
                                            </th>

                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            

                                        </tr>
                                        <tr>
                                            <th className='table-date'>
                                                <div><h6>22-May-2023</h6></div>
                                                <div><h6>to</h6></div>
                                                <div><h6>28-May-2023</h6></div>
                                            </th>

                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            

                                        </tr>
                                        <tr>
                                            <th className='table-date'>
                                                <div><h6>22-May-2023</h6></div>
                                                <div><h6>to</h6></div>
                                                <div><h6>28-May-2023</h6></div>
                                            </th>

                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            

                                        </tr>
                                        <tr>
                                            <th className='table-date'>
                                                <div><h6>22-May-2023</h6></div>
                                                <div><h6>to</h6></div>
                                                <div><h6>28-May-2023</h6></div>
                                            </th>

                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            

                                        </tr>
                                        <tr>
                                            <th className='table-date'>
                                                <div><h6>22-May-2023</h6></div>
                                                <div><h6>to</h6></div>
                                                <div><h6>28-May-2023</h6></div>
                                            </th>

                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    
                                                    <div className='main-result'><h6>22</h6></div>
                                                    
                                                </div>
                                            </td>
                                            

                                        </tr>
                                       

                                    </tbody>
                                </table>


                            </div> */}

                            <div className='panachart-button'>

                                <div className='panachart-back-button' onClick={() => navigate('/market-result')} ><span className='arrow-icon'><img src={arrow} /></span><span className='back'>BACK</span></div>
                                <div className='panachart-top-button' onClick={topToTable} ref={tableBottom} ><span className='arrow-icon'><img src={arrow} /></span><span className='back'>TOP</span></div>

                            </div>

                        </div>

                    </div>

                </div>

            </>

        </div>
    )
}

export default JodiChart
